import { Cell, Grid, Heading, HFlow, Icon, InfoLabel } from 'bold-ui'
import { Color } from 'csstype'
import React from 'react'
import { formatDate } from 'util/date/formatDate'

import { useAcompanhamentoCondicaoSaudeContext } from '../../../context/AcompanhamentoCondicaoSaudeContext'
import { ListaTematicaCidCiapUtilizadosInfoIcon } from '../../lista-tematica/ListaTematicaCidCiapUtilizadosInfoIcon'

interface AcompanhamentoCondicaoSaudeAcompanhamentoHipertensaoSectionProps {
  qtdMedicoesPressaoArterial?: number | null
  dataUltimaConsulta?: LocalDate | null
  qtdConsultas?: number | null
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeAcompanhamentoHipertensaoSection({
  qtdMedicoesPressaoArterial,
  dataUltimaConsulta,
  qtdConsultas,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeAcompanhamentoHipertensaoSectionProps>) {
  const { ciapsConsiderados, cidsConsiderados } = useAcompanhamentoCondicaoSaudeContext()

  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon icon='bloodPressureFilled' size={1} color={iconColor} />
          <Heading level={4}>Acompanhamento da hipertensão</Heading>
          <ListaTematicaCidCiapUtilizadosInfoIcon
            cidsConsiderados={cidsConsiderados}
            ciapsConsiderados={ciapsConsiderados}
          />
        </HFlow>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Consultas (últimos 36 meses)'>{qtdConsultas}</InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Última consulta'>{formatDate(dataUltimaConsulta)}</InfoLabel>
      </Cell>
      <Cell size={3}>
        <InfoLabel title='Medições de P.A. (últimos 36 meses)' placeholder='-'>
          {qtdMedicoesPressaoArterial}
        </InfoLabel>
      </Cell>
    </Grid>
  )
}
